const GO_TEST_NAMES = {
  calendar_reposition: "calendar_reposition",
  syb_home_promo: "syb_home_promo",
  syb_promo: "syb_promo",
  calendar_widget_button: "calendar_widget_button",
  testOneOfferId: "testOneOfferId",
  hls: "hls",
  content: "content",
};

export { GO_TEST_NAMES };
